var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrossMarginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#50CFBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0829 18.7932L29.2849 19.4657C29.4357 19.5499 29.528 19.7019 29.528 19.8658C29.528 20.0298 29.4357 20.1817 29.2849 20.2659L19.9999 25.4619L10.7149 20.2659C10.564 20.1817 10.4717 20.0298 10.4717 19.8658C10.4717 19.7019 10.564 19.5499 10.7149 19.4657L11.9169 18.7932L19.9999 23.3168L28.0829 18.7932ZM28.0829 23.1768L29.2849 23.8493C29.4357 23.9335 29.528 24.0854 29.528 24.2494C29.528 24.4134 29.4357 24.5653 29.2849 24.6495L20.5149 29.5573C20.1979 29.7349 19.8018 29.7349 19.4849 29.5573L10.7149 24.6495C10.564 24.5653 10.4717 24.4134 10.4717 24.2494C10.4717 24.0854 10.564 23.9335 10.7149 23.8493L11.9169 23.1768L19.9999 27.7003L28.0829 23.1768V23.1768ZM20.5139 10.2211L29.2849 15.1289C29.4357 15.2131 29.528 15.365 29.528 15.529C29.528 15.693 29.4357 15.8449 29.2849 15.9291L19.9999 21.1251L10.7149 15.9291C10.564 15.8449 10.4717 15.693 10.4717 15.529C10.4717 15.365 10.564 15.2131 10.7149 15.1289L19.4849 10.2211C19.8018 10.0435 20.1979 10.0435 20.5149 10.2211H20.5139Z",
    fill: "#50CFBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossMarginIcon);
export default __webpack_public_path__ + "static/media/GrossMarginIcon.5ed69d687b8019be9b416f4c6bc4aaaa.svg";
export { ForwardRef as ReactComponent };